import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type AmsPolicyStatusCodesTreeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AmsPolicyStatusCodesTreeQuery = { __typename?: 'Query', amsPolicyStatuses: Array<{ __typename?: 'AmsPolicyStatusWithCodes', aggStatus: Types.AggPolicyStatus, codes: Array<string> }> };


export const AmsPolicyStatusCodesTreeDocument = gql`
    query AmsPolicyStatusCodesTree {
  amsPolicyStatuses {
    aggStatus
    codes
  }
}
    `;

/**
 * __useAmsPolicyStatusCodesTreeQuery__
 *
 * To run a query within a React component, call `useAmsPolicyStatusCodesTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsPolicyStatusCodesTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsPolicyStatusCodesTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAmsPolicyStatusCodesTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>(AmsPolicyStatusCodesTreeDocument, options);
      }
export function useAmsPolicyStatusCodesTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>(AmsPolicyStatusCodesTreeDocument, options);
        }
// @ts-ignore
export function useAmsPolicyStatusCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>;
export function useAmsPolicyStatusCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AmsPolicyStatusCodesTreeQuery | undefined, AmsPolicyStatusCodesTreeQueryVariables>;
export function useAmsPolicyStatusCodesTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>(AmsPolicyStatusCodesTreeDocument, options);
        }
export type AmsPolicyStatusCodesTreeQueryHookResult = ReturnType<typeof useAmsPolicyStatusCodesTreeQuery>;
export type AmsPolicyStatusCodesTreeLazyQueryHookResult = ReturnType<typeof useAmsPolicyStatusCodesTreeLazyQuery>;
export type AmsPolicyStatusCodesTreeSuspenseQueryHookResult = ReturnType<typeof useAmsPolicyStatusCodesTreeSuspenseQuery>;
export type AmsPolicyStatusCodesTreeQueryResult = Apollo.QueryResult<AmsPolicyStatusCodesTreeQuery, AmsPolicyStatusCodesTreeQueryVariables>;